<div class="container-fluid d-flex flex-column flex-grow-1 mainCont mt-5">
  <app-content-heading [icon]='icons.faCloud' class="pt-2" [title]="'Add Server'"
  [registerPage]="true"></app-content-heading>
  <form [formGroup]="serverForm" (ngSubmit)="onNext()" *ngIf="serverForm"
    class="justify-content-between d-flex flex-column flex-grow-1">
    <div class="col-12 col-md-8">

      <div class="col-12 col-md-9 ">


        <div class="form-group row mb-2">
          <label for="environmentName" class="col-form-label col-sm-3">Environment Name</label>
          <div class="col-sm-9">
            <input type="text" id="environmentName" class="form-control form-control-sm"
              formControlName="environmentName" placeholder="Name">
          </div>
        </div>
        <div class="form-group row mb-2">
          <label for="cloudVendor" class="col-form-label col-sm-3">Cloud Vendor</label>
          <div class="col-sm-9">
            <input type="text" id="cloudVendor" class="form-control form-control-sm" formControlName="cloudVendor"
              placeholder="cloud vendor">
          </div>
        </div>
        <div class="form-group row mb-2">
          <label for="region" class="col-form-label col-sm-3">Region</label>
          <div class="col-sm-9">
            <input type="text" id="region" class="form-control form-control-sm" formControlName="region"
              placeholder="region">
          </div>
        </div>
        <div class="form-group row mb-2">
          <label for="serverProfile" class="col-form-label col-sm-3">Server Plan</label>
          <div class="col-sm-9">
            <input type="text" id="serverProfile" class="form-control form-control-sm" formControlName="serverProfile"
              placeholder="serverProfile">
          </div>
        </div>
        <div class="form-group row mb-2">
          <label for="nCacheVersion" class="col-form-label col-sm-3">NCache Version</label>
          <div class="col-sm-9">
            <input type="text" id="nCacheVersion" class="form-control form-control-sm" formControlName="nCacheVersion"
              placeholder="nCacheVersion">
          </div>
        </div>
        <div class="form-group row mb-2">
          <label for="machines" class="col-form-label col-sm-3">Servers</label>
          <div class="col-sm-9">
            <input min="1" type="number" id="machines" class="form-control form-control-sm" formControlName="machines"
            (input)="onMachineChange($event.target.value,$event.target)"
            placeholder="Enter No of Servers">
          </div>
        </div>

        <div class="form-group row mb-2" *ngIf="!this.isPAYG()">
          <label for="machines" class="col-form-label col-sm-3">Servers info</label>
          <div class="col-sm-9">
            <label class="col-form-label col-sm-3 text-danger">Reserved Servers: <span class="">{{getAvailableReservedServers()}}</span></label>
            <label class="col-form-label col-sm-3 text-danger">Pay As You Go: <span class="">{{totalPayGVms}}</span></label>
          </div>
        </div>
      </div>


      <div class="col-sm-12 d-flex">
        <!-- Label with col-sm-5 on the start -->
        <label for="machines" class="col-sm-2 col-md-2 fw-bold text-decoration-underline"
          style="text-underline-offset: 6px;">
          <!-- Your label text here -->
        </label>



        <!-- Empty space (20% width) -->
        <div class="col-sm-2"></div>
      </div>


      <div class="col-sm-12 d-flex ps-4">
        <label for="machines" class="col-sm-2 col-md-2 fw-bold text-decoration-underline"
          style="text-underline-offset: 6px;">
          <!-- Your label text here -->
        </label>
        <!-- <button type="button" class="btn btn-sm btn-nc btn-primary me-3  mt-3 px-4 ">Purchase Annual</button> -->

      </div>



      <div *ngIf="formSubmitted && serverForm.errors?.atLeastOneRequired"
        class="text-danger font-weight-bold p-2 pb-0 mb-0">
        Please add at least one Server.
      </div>
      <div *ngIf="formSubmitted && serverForm.controls?.machines.errors?.pattern"
        class="text-danger font-weight-bold p-2 pb-0 mb-0">
        Please enter valid number.
      </div>
    </div>

    <div class='footer'>

      <button
        class="btn btn-sm btn-outline-primary btn-nc az-btn-space px-3 btn-width"
        [disabled]="true">
          Previous
      </button>

      <button
        type="submit"
        class="btn btn-nc az-btn-space btn-sm submit btn-primary btn-width"
        [disabled]="isCreatingVM">
        Confirm
      </button>

      <button
        type="button"
        class="btn btn-nc az-btn-space btn-sm submit btn-outline-primary btn-width"
        (click)="this.redirectToEnvDetails()">
        Cancel
      </button>

  </div>

  </form>
</div>